import { combineReducers } from 'redux';
import dashboard, { DashboardInitialState } from './dashboard';
import incidents, { IncidentsInitialState } from './incidents';
import electionIncidents, { ElectionIncidentsInitialState } from './election-incident';

export interface RootState {
  dashboard: DashboardInitialState;
  incidents: IncidentsInitialState;
  electionIncidents: ElectionIncidentsInitialState;
}

const rootReducer = combineReducers({ dashboard, incidents, electionIncidents });

export default rootReducer;
